    <template>
        <div class="c-match-handicap" :class="'morebet'+specialType" :id="'cmatch'+event.eveid">
            <div class="vrow no-wrap">
                <template v-for="plytyp in playType">
                    <!-- 1X2 -->
                    <div class="handicap-col" :id="'handicapCol'+event.eveid+betTypeonex2+plytyp+'a'+specialType">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text">
                                        <template v-if="event.od[plytyp] && event.od[plytyp][betTypeonex2] && event.od[plytyp][betTypeonex2]['oddsh']">
                                            <template v-if="selectedLang=='4' || selectedLang=='11'">1</template>
                                            <template v-else>{{ sportAllBetLang['ALL_BET.LBL_HOMEWIN'] }}</template>
                                        </template>
                                    </div>
                                </div>
                                <odd1x2 :event="event" :team="teamHome" :plyType="plytyp" :betType="betTypeonex2" />
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text">
                                        <template v-if="event.od[plytyp] && event.od[plytyp][betTypeonex2] && event.od[plytyp][betTypeonex2]['oddsa']">
                                            <template v-if="selectedLang=='4' || selectedLang=='11'">2</template>
                                            <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                        </template>
                                    </div>
                                </div>
                                <odd1x2 :event="event" :team="teamAway" :plyType="plytyp" :betType="betTypeonex2" />
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text">
                                        <template v-if="event.od[plytyp] && event.od[plytyp][betTypeonex2] && event.od[plytyp][betTypeonex2]['oddsd']">
                                            <template v-if="selectedLang=='4' || selectedLang=='11'">X</template>
                                            <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                        </template>
                                    </div>
                                </div>
                                <odd1x2 :event="event" :team="teamDraw" :plyType="plytyp" :betType="betTypeonex2" />
                            </div>
                        </div>
                    </div>
                    <!-- HDP -->
                    <div class="handicap-col" :id="'handicapCol'+event.eveid+betTypehdp+plytyp+'a'+specialType">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text">
                                        <handicap :event="event" :favTeam="'a'" :plyType="plytyp" :betType="betTypehdp" :match="subMatchKey" />
                                    </div>
                                </div>
                                <odd :event="event" :team="teamA" :plyType="plytyp" :betType="betTypehdp" :match="subMatchKey"></odd>
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text">
                                        <handicap :event="event" :favTeam="'b'" :plyType="plytyp" :betType="betTypehdp" :match="subMatchKey" />
                                    </div>
                                </div>
                                <odd :event="event" :team="teamB" :plyType="plytyp" :betType="betTypehdp" :match="subMatchKey"></odd>
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                    </div>
                    <!-- OU -->
                    <div class="handicap-col" :id="'handicapCol'+event.eveid+betTypeou+plytyp+'a'+specialType">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="width: min-content;">
                                        <template v-if="event.od[plytyp] && event.od[plytyp][betTypeou] && event.od[plytyp][betTypeou][subMatchKey]">
                                            {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                        </template>&nbsp;
                                    </span>
                                    <div class="handicap-value-text">
                                        <over-under :event="event" :plyType="plytyp" :betType="betTypeou" :match="subMatchKey" />
                                    </div>
                                </div>
                                <odd :event="event" :team="teamA" :plyType="plytyp" :betType="betTypeou" :match="subMatchKey"></odd>
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                    <span class="handicap-more" style="width: min-content;">
                                        <template v-if="event.od[plytyp] && event.od[plytyp][betTypeou] && event.od[plytyp][betTypeou][subMatchKey]">
                                            {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                        </template>&nbsp;
                                    </span>
                                    <div class="handicap-value-text">
                                        <over-under :event="event" :plyType="plytyp" :betType="betTypeou" :match="subMatchKey" />
                                    </div>
                                </div>
                                <odd :event="event" :team="teamB" :plyType="plytyp" :betType="betTypeou" :match="subMatchKey"></odd>
                            </div>
                        </div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                    </div>
                </template>

                <!-- Unfold SC All -->
                <template v-if="isUnfold">
                    <template v-for="(n, key) in 5" v-if="widthColumn[3]==2">
                        <div class="handicap-col">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        </div>
                    </template>
                    <template v-for="(n, key) in 6" v-if="widthColumn[3]==1">
                        <div class="handicap-col">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        </div>
                    </template>
                    <template v-for="(n, key) in 7" v-if="widthColumn[3]==0">
                        <div class="handicap-col">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </template>
  
  <script>
  import {
    mapGetters,
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  import OverUnderComponents from '../../../components/over-under'
  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
        event: null,
        plytyp: null,
        widthColumn:null,
        isUnfold:false,
        specialType:null,
        specialEveId:null,
    },
    computed: {
      ...mapGetters([
        'sportAllBetLang',
        'sportTableLang',
      ]),
    },
    data() {
      return {
        selectedLang: window._langid,
        show: true,
        playType: [allBetMixin.data().ftPlyType, allBetMixin.data().firstHtPlyType],
        betTypeonex2: (this.event.rbinfo ? allBetMixin.data().ronex2BetType : allBetMixin.data().onex2BetType),
        betTypehdp: (this.event.rbinfo ? allBetMixin.data().rhdpBetType : allBetMixin.data().hdpBetType),
        betTypeou: (this.event.rbinfo ? allBetMixin.data().rouBetType : allBetMixin.data().ouBetType),
        betTypeoe: (this.event.rbinfo ? allBetMixin.data().roeBetType : allBetMixin.data().oeBetType),
        lang: window.lang,
        subMatchKey: 'a',
      }
    },
    methods: {
    },
    mouted(){
    },
    beforeMount() {
        // console.log(this.specialEveId)
    },
  }
  </script>
  <style lang="scss">
  .bluebg{
    background-color: var(--qq--yb-bg-color23);
  }

  .color-highlight{
    color: var(--qq--yb-text-color20);
    font-weight: 500;
    white-space: nowrap;
    margin-left: 1px;
    margin-right: 3px;
  }

  .odds-right{
    margin-right: 3px  !important;
  }

  .morebetdual .handicap-value {
    position: absolute;
    left: 0;
    width: 63%;
    margin-left: 6px;
    justify-content: center;
  }
  </style>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/moreBet-special.vue